import { Component, OnInit } from '@angular/core';
import { ArkUnitOfWork } from 'app/core/core.module';
import { TextMessageSent } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-sents-dialog',
    standalone: true,
    imports: [SharedModule],
    template: `
        <div class="modal-header"><h2 class="modal-title">Message Sents</h2></div>
        <div class="modal-body">
            @if (messageSents) {
                <div class="grid-fill">
                    <dx-data-grid [dataSource]="messageSents" keyExpr="id" height="700px">
                        <dxi-column dataField="person.displayName" caption="Sent To"></dxi-column>
                        @if (mode === 'email') {
                            <dxi-column dataField="person.email" caption="Email"></dxi-column>
                        }
                        @if (mode === 'text') {
                            <dxi-column dataField="person.cellPhone" caption="Cell"></dxi-column>
                        }
                        <dxi-column dataField="sent" caption="Sent" format="shortDateShortTime"></dxi-column>
                        <dxi-column dataField="id"></dxi-column>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                    </dx-data-grid>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
        </div>
    `,
})
export class SentsDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    messageId: number;
    mode: string = 'text';
    messageSents: any;

    constructor(
        public modalRef: BsModalRef,
        private uow: ArkUnitOfWork,
    ) {}

    async ngOnInit() {
        if (this.mode === 'text') this.messageSents = (await this.uow.getTextMessageSentsByMessageId(this.messageId)) as TextMessageSent[];
        else this.messageSents = (await this.uow.getEmailMessageSentsByMessageId(this.messageId)) as TextMessageSent[];
    }

    cancel() {
        this.modalRef.hide();
    }
}
